<template>
    <v-dialog
            v-model="value"
            max-width="520"
    >
        <v-card>
            <v-card-title class="headline"><span v-html="$t('home.loginModalTitle')"></span></v-card-title>

            <v-card-text>
                <span v-html="$t('home.loginModalContent')"></span>
                <v-flex style="padding-left:10px;margin-top: 75px; min-height: 80px;">


                    <sign-in-button @completed="onCompleted" :source="'website'"></sign-in-button>


                </v-flex>



            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        color=" darken-1"
                        text
                        @click="close"
                >
           <span ><span v-html="$t('home.loginModalClose')"></span>
</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style>


</style>

<script>
    import SignInButton from '../components/signInButton'


    export default {
        name: 'Modal_SignIn',
        props: ['value'],
        data: () => ({}),
        methods: {

            close(){
                this.$emit('input', false);
            },
            onCompleted(payload){
                this.$UAnalytics.signedIn();
                this.$emit('completed', payload);

            }
        },
        components: {

            SignInButton

        },
        watch: {
            value(v){
                this.$emit('input', v);
            }
        }
    };
</script>
